import type React from 'react';

import { observer } from 'mobx-react';

import { TextField } from '@material-ui/core';

import { useAction } from 'bz-utilities/hooks/action';

import type OptionsDetailsStore from '../../store/option-details';

export interface IProps {
  details: OptionsDetailsStore;
}

const OptionsDetailsInput: React.FC<IProps> = observer(({ details }) => {
  const onChange = useAction(
    (e: React.ChangeEvent<HTMLInputElement>): void => {
      details.description = e.target.value;
    },
    [details]
  );

  return (
    <TextField
      className="description col-span-5 col-start-1"
      fullWidth={true}
      value={details.description}
      onChange={onChange}
    />
  );
});

OptionsDetailsInput.displayName = 'OptionsDetailsInput';

export default OptionsDetailsInput;
